import axiosInstance from "./AxiosInstanceMain";

// 🔹 COMMON RESPONSE HANDLER
const handleResponse = (res) => {
  return {
    success: true,
    data: res?.data?.data || res?.data,
    message: res?.data?.message || "Success",
  };
};

// 🔹 COMMON ERROR HANDLER
const handleError = (error) => {
  return {
    success: false,
    message: error?.error || error?.message || "Something went wrong",
    data: null,
  };
};

// 🧱 1. GET ALL PROJECTS
export const getProjectsApi = async (params = {}) => {
  try {
    const res = await axiosInstance.get("/project/projects", { params });
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 2. GET PROJECT BY ID
export const getProjectByIdApi = async (id) => {
  try {
    const res = await axiosInstance.get(`/project/project/${id}`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 3. CREATE PROJECT
export const createProjectApi = async (data) => {
  try {
    const res = await axiosInstance.post("/project/create-project", data);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 4. UPDATE PROJECT
export const updateProjectApi = async (id, data) => {
  try {
    const res = await axiosInstance.put(`/project/update-project/${id}`, data);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 5. DELETE PROJECT (SOFT)
export const deleteProjectApi = async (id) => {
  try {
    const res = await axiosInstance.delete(`/project/delete-project/${id}`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 6. HARD DELETE
export const hardDeleteProjectApi = async (id) => {
  try {
    const res = await axiosInstance.delete(`/project/hard-delete-project/${id}`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 7. BULK DELETE
export const bulkDeleteProjectsApi = async (ids = []) => {
  try {
    const res = await axiosInstance.post(`/project/bulk-delete-projects`, {
      projectIds: ids,
    });
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 8. UPDATE STATUS
export const updateProjectStatusApi = async (id, isActive) => {
  try {
    const res = await axiosInstance.patch(`/project/project-status/${id}`, {
      isActive,
    });
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 9. RESTORE PROJECT
export const restoreProjectApi = async (id) => {
  try {
    const res = await axiosInstance.patch(`/project/restore-project/${id}`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 10. SEARCH PROJECTS
export const searchProjectsApi = async (keyword) => {
  try {
    const res = await axiosInstance.get(`/project/projects-search`, {
      params: { keyword },
    });
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 11. OVERVIEW
export const getProjectsOverviewApi = async () => {
  try {
    const res = await axiosInstance.get(`/project/projects-overview`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 12. STATS
export const getProjectsStatsApi = async () => {
  try {
    const res = await axiosInstance.get(`/project/projects-stats`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// ================= CONFIGURATIONS =================

// 🧱 13. GET CONFIGS
export const getConfigurationsApi = async (projectId) => {
  try {
    const res = await axiosInstance.get(`/project/configurations/${projectId}`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 14. ADD CONFIG
export const addConfigurationApi = async (projectId, data) => {
  try {
    const res = await axiosInstance.post(
      `/project/add-configuration/${projectId}`,
      data
    );
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 15. UPDATE CONFIG
export const updateConfigurationApi = async (id, data) => {
  try {
    const res = await axiosInstance.put(
      `/project/update-configuration/${id}`,
      data
    );
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 16. DELETE CONFIG
export const deleteConfigurationApi = async (id) => {
  try {
    const res = await axiosInstance.delete(
      `/project/delete-configuration/${id}`
    );
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// ================= TOWERS =================

// 🧱 17. GET TOWERS
export const getTowersApi = async (projectId) => {
  try {
    const res = await axiosInstance.get(`/project/towers/${projectId}`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 18. ADD TOWER
export const addTowerApi = async (projectId, data) => {
  try {
    const res = await axiosInstance.post(`/project/add-tower/${projectId}`, data);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 19. UPDATE TOWER
export const updateTowerApi = async (id, data) => {
  try {
    const res = await axiosInstance.put(`/project/update-tower/${id}`, data);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 20. DELETE TOWER
export const deleteTowerApi = async (id) => {
  try {
    const res = await axiosInstance.delete(`/project/delete-tower/${id}`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 21. PROJECT SETUP (CONFIG + TOWER)
export const setupProjectApi = async (projectId, data) => {
  try {
    const res = await axiosInstance.post(
      `/project/project-setup/${projectId}`,
      data
    );
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 22. GET ACTIVE PROJECTS
export const getActiveProjectsApi = async () => {
  try {
    const res = await axiosInstance.get(`/project/projects-active`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 23. GET INACTIVE PROJECTS
export const getInactiveProjectsApi = async () => {
  try {
    const res = await axiosInstance.get(`/project/projects-inactive`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 24. GET ALL PROJECTS (ADMIN)
export const getProjectsAdminApi = async () => {
  try {
    const res = await axiosInstance.get(`/project/projects-admin`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// ================= AMENITIES =================

// 🧱 25. GET ALL AMENITIES
export const getAmenitiesApi = async (params = {}) => {
  try {
    const res = await axiosInstance.get(`/amenity/amenities`, { params });
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 26. GET AMENITY BY ID
export const getAmenityByIdApi = async (id) => {
  try {
    const res = await axiosInstance.get(`/amenity/amenity/${id}`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 27. CREATE AMENITY
export const createAmenityApi = async (data) => {
  try {
    const res = await axiosInstance.post(`/amenity/create-amenity`, data);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 28. UPDATE AMENITY
export const updateAmenityApi = async (id, data) => {
  try {
    const res = await axiosInstance.put(
      `/amenity/update-amenity/${id}`,
      data
    );
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 29. DELETE AMENITY (SOFT)
export const deleteAmenityApi = async (id) => {
  try {
    const res = await axiosInstance.delete(
      `/amenity/delete-amenity/${id}`
    );
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 30. RESTORE AMENITY
export const restoreAmenityApi = async (id) => {
  try {
    const res = await axiosInstance.patch(
      `/amenity/restore-amenity/${id}`
    );
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 31. TOGGLE AMENITY STATUS
export const toggleAmenityStatusApi = async (id, isActive) => {
  try {
    const res = await axiosInstance.patch(
      `/amenity/amenity-status/${id}`,
      { isActive }
    );
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};

// 🧱 32. GET INACTIVE AMENITIES
export const getInactiveAmenitiesApi = async () => {
  try {
    const res = await axiosInstance.get(
      `/amenity/amenities-inactive`
    );
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};
// 🧱 33. GET PROJECT BY SLUG
export const getProjectBySlugApi = async (slug) => {
  try {
    const res = await axiosInstance.get(`/project/project-slug/${slug}`);
    return handleResponse(res);
  } catch (error) {
    return handleError(error);
  }
};